<template>
  <validation-provider
    v-slot="{ errors, failed }"
    :name="item.name"
    :rules="validationRules"
  >
    <div :class="{'validation-failed':failed}">
      <item-name :item="item" />
      <div class="flex flex-row md:flex-col">
        <div class="flex flex-col md:flex-row">
          <template v-for="(rangeItem, index) in range">
            <div
              :key="itemName + '-option-' + index"
              class="m-1 md:m-2 flex-1 flex-grow w-18 h-18 md:h-auto"
            >
              <label
                :for="itemName + '-option-' + index"
                :class="{ 'gradient' : isSelected(rangeItem)}"
                class="block border-3 cursor-pointer flex font-body items-center justify-center text-2xl text-center focus-within:border-orange-700 h-full"
              >
                <input
                  :id="itemName + '-option-' + index"
                  v-model="value"
                  :name="itemName"
                  :value="rangeItem"
                  type="radio"
                  class="sr-only"
                >
                <span class="font-bold md:text-3xl">{{ rangeItem }}</span>
              </label>
            </div>
          </template>
        </div>
        <div class="flex flex-col md:flex-row justify-between">
          <div
            v-if="item.meta.range.start_label"
            class="p-2 flex h-18 md:h-auto items-center"
          >
            {{ item.meta.range.start_label }}
          </div>
          <div
            v-if="item.meta.range.end_label"
            class="p-2 flex h-18 md:h-auto items-center"
          >
            {{ item.meta.range.end_label }}
          </div>
        </div>
      </div>

      <item-errors :errors="errors" />
    </div>
  </validation-provider>
</template>

<script>
import ItemMixin from './item-mixin'
import ItemName from './item-name'
import ItemErrors from './item-errors'

export default {
  components: {
    ItemName,
    ItemErrors
  },
  mixins: [
    ItemMixin
  ],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    range: function () {
      let rangeArray = []
      for (let i = this.item.meta.range.start; i <= this.item.meta.range.end; i++) {
        rangeArray.push(i)
      }
      return rangeArray
    }
  },
  methods: {
    isFirstRangeItem (item) {
      console.log(this.range[0], item, this.range[0] === item)
      return this.range[0] === item
    },
    isLastRangeItem (item) {
      return this.range[this.range.length - 1] === item
    }
  }
}
</script>
